import { useNavigate } from 'react-router-dom'
import Button from '../../common/components/Button'
import ProfileBase from '../../components/Profile/ProfileBase'
import style from './Profile.module.css'
import { useAuth } from '../../common/context/AuthContext'
import { t } from 'i18next'

const Profile = () => {
  const navigate = useNavigate()
  const { logoutUser } = useAuth()

  const onLogoutClick = async () => {
    await logoutUser()
    navigate('/')
  }

  const onChangePasswordClick = () => {
    navigate('/profile/change-password')
  }

  const onChangePrioritiesClick = () => {
    navigate('/profile/change-priorities')
  }

  const onChangeLanguageClick = () => {
    navigate('/profile/change-language')
  }

  return (
    <ProfileBase
      backButtonAction={() => navigate('/feed')}
      buttonTitle={t('profile.logout')}
      onButtonClick={onLogoutClick}
      title={t('profile.title')}
    >
      <div className={style.buttonsContainer}>
        <Button
          title={t('profile.changePassword')}
          onClick={onChangePasswordClick}
        />
        <Button
          title={t('profile.changePriorities')}
          onClick={onChangePrioritiesClick}
        />
        <Button
          title={t('profile.changeLanguage')}
          onClick={onChangeLanguageClick}
        />
      </div>
    </ProfileBase>
  )
}

export default Profile
